<template>
  <div id="about">
    <div class="banner">
      <img  id="we" src="../../../assets/image/about/banner_aboutus.png" alt="">
    </div>
    <div class="main_info">
      <div class="main_l">
        <div id="left_nav" :class="searchBarFixed? 'fixed_nav' : 'left_nav' ">
          <ul>
            <li :class="NavNum === 1 ? 'activeli': 'nav_li'"  @click="checkLi(1)"><span>关于我们</span></li>
            <li :class="NavNum === 2 ? 'activeli': 'nav_title'" @click="checkLi(2)"><span>合作伙伴</span></li>
            <li :class="NavNum === 3 ? 'activeli': 'nav_li'" @click="checkLi(3)"><span>法律顾问</span></li>
            <li :class="NavNum === 4 ? 'activeli': 'nav_title'" @click="checkLi(4)"><span>联系我们</span></li>
          </ul>
        </div>
      </div>
      <div class="main_r">
        <div class="profile wow bounceIn">
          <h3>公司简介</h3>
          <p>Company profile</p>
          <div  class="we_about">
            <p>成都泽谷文化传媒有限公司(位于成都市博雅城市广场)是一家集主播培训、主播人力资源输送、MCN机构服务，新媒体运营、网络营销推广、企业形象策划，产品营销推广、摄影制做、网络直播、活动策划、
              广告发布、演出经纪、等商业服务于一体的文化传播机构多元化、专业性的传媒公司。</p>
            <p>传媒策划业务群专为政府、央企国企、互联网、医药等各行业客户提供大型庆典活动策
              划执行全年各类型活动、会议、会展、发布会、演唱会等。</p>
            <p>主播培训业务群签约国家广播电视总局广播电视和网络视听播音主持教育培训基地，成
              为西南片区独家授权教培中心，拥有主播技能鉴定、培训、主播赛事举行、运营、授权资
              质，为各大直播平台以及MCN机构输送了大量优质主播资源。</p>
            <p>企业服务业务群通过自身以及合作机构签约的主播、明星艺人为企业在品牌营销、电商带
              货、短视频代运营方面提供一站式托管服务。</p>
            <p>泽谷传媒始终秉持专业化的人才与优质的服务，以便捷省心的一站式服务、个性化的策划，
              整合各方资源优势，坚持“以客户为中心、以真诚赢得信赖，为客户创造价值”。</p>
          </div>
          <div class="bg_jj">
            <img src="../../../assets/image/about/guanyuwomenzhengshu.png" alt="">
          </div>
        </div>
        <div class="vision">
          <h3>公司愿景</h3>
          <p>The company vision</p>
          <div class="vision_box" id="company">
            <p style="text-indent: 2em;">我们始终致力于合作伙伴的成长与收获，为此，我们构建起更为灵活的合作架构，敏锐洞
              察市场的细微变化，时刻为合作伙伴提供优质高效的MCN机构服务。从创作到推广，从线下
              到线上，我们的服务涉及广电授权教育培训与MCN两大板块业务，为合作伙伴提供全程解决
              方案，让机构更具有传播性，让传播更具目的性，从而为合作伙伴节省更多的时间与精力，
              助推合作伙伴提升企业核心竞争力。</p>
          </div>
        </div>
        <div class="partners" >
          <h3>合作伙伴</h3>
          <p>Company partners</p>
          <div  class="partners_box wow bounceInUp">
            <div class="partners_logo_t">
              <div class="top_logo">
                <img src="../../../assets/image/about/wiemi.png" alt="火山小视频">
              </div>
              <p>微米互动</p>
            </div>
            <div class="partners_logo_t">
              <div class="top_logo">
                <img src="../../../assets/image/about/toubang.png" alt="趣头条">
              </div>
              <p>头榜</p>
            </div>
            <div class="partners_logo_t">
              <div class="top_logo">
                <img src="../../../assets/image/about/pop.png" alt="抖音">
              </div>
              <p>POP传媒</p>
            </div>
            <div class="partners_logo_t">
              <div class="top_logo">
                <img src="../../../assets/image/about/jdjx.png" alt="快手">
              </div>
              <p>嘉德佳信</p>
            </div>
            <div class="partners_logo_t">
              <div class="top_logo">
                <img src="../../../assets/image/about/zhongji.png" alt="大鱼号">
              </div>
              <p>中基惠城</p>
            </div>
            <div class="partners_logo_c">
              <div class="top_logo">
                <img src="../../../assets/image/about/zyyb.png" alt="百家号">
              </div>
              <p>中运远骅</p>
            </div>
            <div class="partners_logo_c">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_douyin.png" alt="映客">
              </div>
              <p>抖音</p>
            </div>
            <div class="partners_logo_c">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_xiguaxiaoshipin.png" alt="西瓜小视频">
              </div>
              <p>西瓜小视频</p>
            </div>
            <div class="partners_logo_c">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_huya.png" alt="虎牙">
              </div>
              <p>虎牙</p>
            </div>
            <div class="partners_logo_c">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_douyu.png" alt="斗鱼">
              </div>
              <p>斗鱼</p>
            </div>
            <div class="partners_logo_b">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_yy.png" alt="YY">
              </div>
              <p>YY</p>
            </div>
            <div id="Legalsupport" class="partners_logo_b">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_qie.png" alt="企鹅直播">
              </div>
              <p>企鹅直播</p>
            </div>
            <div class="partners_logo_b">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_toutiao.png" alt="头条">
              </div>
              <p>头条</p>
            </div>
            <div class="partners_logo_b">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_baijiahao.png" alt="美拍">
              </div>
              <p>百家号</p>
            </div>
            <div class="partners_logo_b" id="support">
              <div class="top_logo">
                <img src="../../../assets/image/about/icon_kuaishou.png" alt="豆瓣">
              </div>
              <p>快手</p>
            </div>
          </div>
        </div>
        <div class="support">
          <h3>法律顾问</h3>
          <p id="support" class="Legal">Legal support</p>
          <div class="support_box">
            <div class="support_l wow bounceIn">
              <img src="../../../assets/image/about/falvzhichi.png" alt="">
            </div>
            <div class="support_r wow bounceInRight">
              <p>孙科峰 资深律师</p>
              <p>执业15年，发表专业论文20余篇。
                浙江法校律师事务所（简称“法校”）系经浙江省司法厅批准设立的一家首
                推标准化服务的综合性律师事务所，齐全的服务产品、规范的服务标准，专
                业的律师团队、高效的服务流程、优质的服务行为、创新的服务模式，能够
                为客户提供第一时间的标准化法律服务。</p>
              <div id="cont" class="line"></div>
            </div>
          </div>
        </div>
        <div class="contact">
          <h3>联系我们</h3>
          <p>Contact us</p>
          <div id="contact" class="contact_box">
            <div class="contact_l">
              <div class="way">
                <p>Email:</p>
                <p class="way_info">info@zhilu.cn</p>
              </div>
              <div class="way">
                <p>Phone:</p>
                <p class="way_info">400-6520-677</p>
                <p class="way_info">028-85213386</p>
              </div>
              <div class="way">
                <p>QQ:</p>
                <a class="way_info" href="tencent://message/?uin=38897700&amp;Site=Sambow&amp;Menu=yes">38897700</a>
              </div>
              <div class="way">
                <p>WeChat:</p>
                <p class="way_info">13689055040</p>
              </div>
              <div class="way">
                <p>Address:</p>
                <p class="way_info">成都市武侯区长益路143号1层</p>
              </div>
            </div>
            <div class="contact_r">
              <img src="../../../assets/image/about/bg_lianxiwomen.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
  metaInfo() {
    return this.metaData;
  },
  name: '',
  data() {
    return {
      searchBarFixed: false,
      NavNum: 1,
      metaData:{
        title:"关于我们_公司简介_泽谷传媒",
        meta:[
          {
            name:"keyWords",
            content:"全媒体运营师培训合作授权、主播培训、主播输送"
          },
          {
            name:"desciption",
            content:"泽谷传媒是一家集全媒体运营师培训、主播培训、主播人力资源输送、MCN机构服务，品牌直播代运营等直播短视频领域综合服务于一体的传媒公司。致力于成为电商直播的一站式服务商。"
          }
        ]
      }
    };
  },
  methods: {
    checkLi(a) {
      if(a === 1) {
        this.NavNum = a
        const returnEle = document.querySelector("#we");  //productId是将要跳转区域的id
        if (returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        // document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
      }
      if(a === 2) {
        this.NavNum = a
        const returnEle = document.querySelector("#company");  //productId是将要跳转区域的id
        if (returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
      }
      if(a === 3) {
        this.NavNum = a
        const returnEle = document.querySelector("#support");  //productId是将要跳转区域的id
        if (returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
      }
      if(a === 4) {
        this.NavNum = a
        const returnEle = document.querySelector("#contact");  //productId是将要跳转区域的id
        if (returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
      }
    },
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let offsetTop = document.querySelector('#left_nav').offsetTop
      if(scrollTop>89 && scrollTop<1630) {
        this.NavNum = 1
      } else if(scrollTop>1631 && scrollTop<2210) {
        this.NavNum = 2
      } else if(scrollTop>2210 && scrollTop<2722) {
        this.NavNum = 3
      } else {
        this.NavNum = 4
      }
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    },
    // 判断是否为移动端
    isMobile(ua) {
      return !!ua.match(/AppleWebKit.*Mobile.*/)
    }

  },
  mounted(){
    if(this.isMobile(navigator.userAgent)){
      let url = window.location.origin.replace(/www./, "m.");
      window.location.href=url+'/page/h5/about.html'
    }
    window.scrollTo()
    window.addEventListener('scroll', this.handleScroll)
     this.$nextTick(()=>{
      let wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true
      })
      wow.init()
    })
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
#about{
  width: 100%;
  min-width: 1200px;
  .banner {
    width: 100%;
    height: 552px;
    img{
      display: block;
      width: 100%;
      height: 100%;
      max-height: 550px;
    }
  }
  .main_info {
    width: 1200px;
    margin: 70px auto 50px;
    display: flex;
    justify-content: space-between;
    .main_l {
      .left_nav {
        width: 272px;
        height: 256px;
        background: #FFFFFF;
        box-shadow: 0px 0px 13px 0px rgba(53,80, 100,0.24);
        border-radius: 6px;
        font-size: 16px;
        ul {
          li {
            list-style: none;
            >span {
              display: inline-block;
              width: 100%;
              height: 30px;
              line-height: 30px;
              margin-top: 20px;
              
            }
          }
          :hover {
            color: #6D61F4;  
          }
          :hover >span {
            border-left: 3px solid #6d61f4;
          }
        }
        .nav_li {
          list-style: none;
          width: 272px;
          height: 64px;
          background: #ffffff;
          cursor: pointer;
        }
        .nav_title {
          list-style: none;
          width: 272px;
          height: 64px;
          background: #FBFDFF;
          cursor: pointer;
        }
        .activeli {
          list-style: none;
          width: 272px;
          height: 64px;
          background: #ffffff;
          text-align: center;
          line-height: 64px;
          cursor: pointer;
          color: #6D61F4;
        }
      }
      .fixed_nav {
        position: fixed;
        top: 30%;
        width: 272px;
        height: 256px;
        background: #FFFFFF;
        box-shadow: 0px 0px 13px 0px rgba(53,80, 100,0.24);
        border-radius: 6px;
        font-size: 16px;
        ul {
          li {
            list-style: none;
            // :hover span {
            //   border-left: 3px solid #6D61F4;
            // }
            >span {
              display: inline-block;
              width: 100%;
              height: 30px;
              line-height: 30px;
              margin-top: 20px;
            }
          }
          :hover {
            color: #6D61F4;  
          }
          :hover >span {
            border-left: 3px solid #6d61f4;
          }
        }
        .nav_li {
          list-style: none;
          width: 272px;
          height: 64px;
          background: #ffffff;
          cursor: pointer;
        }
        .nav_title {
          list-style: none;
          width: 272px;
          height: 64px;
          background: #FBFDFF;
          cursor: pointer;
        }
        .activeli {
          list-style: none;
          width: 272px;
          height: 64px;
          background: #ffffff;
          cursor: pointer;
          color: #6D61F4;
        }
      }
    }
    .main_r {
      width: 73%;
      text-align: center;
      h3 {
          font-size: 32px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #2B3748;
          line-height: 20px;
      }
      p {
          margin-top: 8px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #7D8A9C;
          line-height: 28px;
      }
      .profile {
        width: 100%;
        .we_about {
          width: 850px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #2B3748;
          line-height: 21px;
          text-align: left;
          p{
            text-indent: 2em;
          }
        }
        .bg_jj {
          margin-top: 30px;
          height: 284px;
          margin-bottom: 90px;
        }
      }
      .vision{
        width: 100%;
        .vision_box {
          height: 75px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #2B3748;
          text-align: left;
          margin-bottom: 87px;
        }
      }
      .partners {
        width: 100%;
        .partners_box {
          width: 100%;
          display: flex;
          // justify-content: space-between;
          flex-wrap: wrap;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #2B3748;
          .partners_logo_t {
            width: 19.5%;
            height: 175px;
            text-align: center;
            border-right: 1px solid #F3F3F3;
            .top_logo {
              width: 100%;
              height: 50%;
              padding-top: 30px;
            }
          }
          .partners_logo_t:last-child {
            border-right: none;
          }
          .partners_logo_c {
            width: 19.5%;
            height: 175px;
            text-align: center;
            border-right: 1px solid #F3F3F3;
            border-top: 1px solid #F3F3F3;
            border-bottom: 1px solid #F3F3F3;
            .top_logo {
              width: 100%;
              height: 50%;
              padding-top: 30px;
            }
          }
          .partners_logo_c:last-child {
            border-right: none; 
          }
          .partners_logo_b {
            width: 19.5%;
            height: 175px;
            text-align: center;
            border-right: 1px solid #F3F3F3;
            .top_logo {
              width: 100%;
              height: 50%;
              padding-top: 30px;
            }
          }
          .partners_logo_b:last-child {
            border-right: none;
          }
        }
      }
      .support {
        width: 100%;
         .support_box {
          margin-top: 50px;
          display: flex;
          justify-content: space-between;
          .support_l {
            width: 50%;
            img {
              width: 434px;
              height: 264px;
            }
          }
          .support_r {
            width: 50%;
            position: relative;
            text-align: left;
            margin-left: 30px;
            .line {
              width: 400px;
              height: 1px;
              background: #E0DEF8;
            }
            p {
              margin-top: 8px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #7D8A9C;
              line-height: 28px;
            }
             p:first-child {
              color: #666666;
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
      }
      .contact {
        width: 100%;
        margin-top: 85px;
        .contact_box {
          display: flex;
          justify-content: space-between;
          .contact_l {
            .way {
              text-align: left;
              margin-bottom: 12px;
              p {
                margin: 0;
                padding: 0;
                font-size: 14px;
              }
              .way_info {
                color: #6D61F4;
                text-decoration: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
